module.exports = __webpack_public_path__ + "img/heroBg3.b975729a.png";